// Pasted Granola text is untrusted (spec 07, manual mode). It is only ever rendered as text.
export const MAX_PASTE_CHARS = 50_000;
export const MAX_TITLE_CHARS = 200;
/** Lines longer than this are kept as plain text and never matched by a parser regex (linear-time guard). */
export const MAX_LINE_REGEX_CHARS = 1000;

/* eslint-disable no-control-regex, no-misleading-character-class -- intentionally matches control and invisible characters */
// C0/C1 controls except tab/newline, DEL, soft hyphen, CGJ, ALM, Mongolian vowel separator, zero-width marks,
// bidi overrides/isolates, invisible operators (U+2060-206F), variation selectors, interlinear annotation,
// BOM and tag characters.
const UNSAFE =
  /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F-\u009F\u00AD\u034F\u061C\u180E\u200B-\u200F\u202A-\u202E\u2060-\u206F\uFE00-\uFE0F\uFEFF\uFFF9-\uFFFB\u{E0000}-\u{E007F}]/gu;
/* eslint-enable no-control-regex, no-misleading-character-class */

function trimEndBlanks(line: string): string {
  let end = line.length;
  while (end > 0 && (line[end - 1] === " " || line[end - 1] === "\t")) end--;
  return end === line.length ? line : line.slice(0, end);
}

/** Throws RangeError("too_large") when the NFC text exceeds MAX_PASTE_CHARS. All steps are linear-time. */
export function sanitizePastedText(raw: string): string {
  if (raw.length > MAX_PASTE_CHARS * 2) throw new RangeError("too_large");
  const text = raw
    .replace(/[\u2028\u2029]/g, "\n")
    .replace(/\u00A0/g, " ")
    .replace(UNSAFE, "")
    .normalize("NFC");
  if (text.length > MAX_PASTE_CHARS) throw new RangeError("too_large");
  return text
    .replace(/\r\n?/g, "\n")
    .replace(/(?<=\S)[ \t]{2,}/g, " ")
    .split("\n")
    .map(trimEndBlanks)
    .join("\n")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}
